<template>
    <div class="popup-wrap" v-if="popup.show">
        <Overlay
            :show="true"
            :opacity=".5"
            @click="$emit('close')"
        />
        <div class="popup" :style="`background-image: url(${require('@/assets/Images/LogoEmblemWatermark.png')}); z-index: ${popup.topography};`">
            <div class="flex-y-center heading">
                <h1>{{ popup.title }}</h1>
                <div class="btn button-white-wrap flex-right margin-r">
                    <div class="button-white" @click="$emit('save-search')">
                        <span>Apply</span>
                    </div>
                </div>
                <img class="btn" src="@/assets/Images/Close.png" alt="Close" title="Close" width="25" height="25" @click="$emit('close')"/>
            </div>
            <div class="content">
                <PopupTimelineYearProjectList
                    v-if="popup.content === 'TimelineYearProjectList'"
                    :projects="popup.projects"
                    @view-project="$emit('view-project', $event)"
                />
                <PopupSearch
                    v-if="popup.content === 'Search' && popup.search.types"
                    :types="popup.search.types"
                    @set-search="$emit('set-search', $event)"
                    @deselect-all-types="$emit('deselect-all-types')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Overlay from "@/components/Overlay.vue";
import PopupTimelineYearProjectList from "@/components/Popups/Content/TimelineYearProjectList.vue";
import PopupSearch from "@/components/Popups/Content/Search.vue";

export default {
    name: "Popup",
    props: { popup: Object },
    components: {
        Overlay,
        PopupTimelineYearProjectList,
        PopupSearch
    },
    emits: [
        "close",
        "view-project",
        "set-search",
        "save-search",
        "deselect-all-types"
    ]
};
</script>